import React, { Component } from 'react';
import { Link } from 'react-router';

import routeConfig from '../../config/route.json';
import { browserHistory } from 'react-router';

import moment from 'moment';
import { Scrollbars } from 'react-custom-scrollbars';


import '../../css/footer-notes.css';

import $ from 'jquery';

let informationText = [{
  en: {
    title: '',
    content: '',
    continue: 'GO'
  },
  tc: {
    title: '',
    content: '',
    continue: '繼續'
  },
  sc: {
    title: '',
    content: '',
    continue: '继续'
  }
}]


const copyrightText = {
  en: {
    title: '<br><br><br><br><br><br><br><br><br>COPY RIGHT AND TRADE MARK',
    content: 'Sun Hung Kai Properties and the other parties own the trade marks, trade names and logos displayed on this website. These may not be used without written consent of Sun Hung Kai Properties or the parties owning them.<br><br>'
      + 'All information and materials on this website are protected by copyright. No part of such information or materials may be modified, reproduced, stored, transmitted, copied, distributed or used in any way for commercial or public purposes without prior written consent of Sun Hung Kai Properties.',
    continue: 'GO'
  },
  tc: {
    title: '<br><br><br><br><br><br><br><br><br>版權與商標',
    content: '本網站所顯示的商標、商號和標誌，由新鴻基地產及其他相關人士擁有，未經新鴻基地產或該等人士的書面同意，不可使用此等商標、商號和標誌。<br><br>'
      + '本網站所載的資訊及材料受版權保護。未經新鴻基地產事前書面同意，不可將此等資料及材料的任何部分修改、翻版、儲存、傳送、複製、分發或以任何方式作商業或公眾用途。',
    continue: '繼續'
  },
  sc: {
    title: '<br><br><br><br><br><br><br><br><br>版权与商标',
    content: '本网站所显示的商标、商号和标誌，由新鸿基地产及其他相关人士拥有，未经新鸿基地产或该等人士的书面同意，不可使用此等商标、商号和标誌。<br><br>'
      + '本网站所载的资讯及材料受版权保护。未经新鸿基地产事前书面同意，不可将此等资料及材料的任何部分修改、翻版、储存、传送、複製、分发或以任何方式作商业或公众用途。',
    continue: '继续'
  }
}

let counter = 0;

/*
      informationText.push(        {
          en: {
            title: '<br><br><br><br><br>Information to purchasers and disclaimers',
            content: 'Name of the Phase of the Development: Phase 2 (“the Phase”) of St. Barths Development (“the Development”)<br>'
              + '(41 Houses and 26 Villas of the residential development in the Phase are called “Crown of St. Barths”)<br>'
              + 'District: Ma On Shan | Name of Street and Street Number of the Phase: 9 Yiu Sha Road<br>'
              + 'The website address designated by the Vendor for the Phase: www.stbarths.com.hk/p2<br><br>'
              + 'Vendor: Good Assets Limited | Holding companies of the Vendor: Sun Hung Kai Properties Limited, Time Effort Limited, China Benefit Holdings Limited | Authorized person of the Phase: Ip Kar-Wai Kelvin | Firm or corporation of which the authorized person of the Phase is a proprietor, director or employee in his professional capacity: Ronald Lu & Partners (Hong Kong) Limited | Building contractor of the Phase: Teamfield Building Contractors Limited | The firm of solicitors acting for the owner in relation to the sale of residential properties in the Phase: Mayer Brown, Sit, Fung, Kwong & Shum | Authorized institution that has made a loan, or has undertaken to provide finance for the construction of the Phase: The Hongkong and Shanghai Banking Corporation Limited | Any other person who had made a loan for the construction of the Phase: Sun Hung Kai Properties Holding Investment Limited<br><br>'
              + 'The photographs, images, drawings or sketches shown in this advertisement/promotional material represent an artist’s impression of the development concerned only. They are not drawn to scale and/or may have been edited and processed with computerized imaging techniques. Prospective purchasers should make reference to the sales brochure for details of the development. The vendor also advises prospective purchasers to conduct an on-site visit for a better understanding of the development site, its surrounding environment and the public facilities nearby.<br><br>'
              + 'The photos and drawings shown in this advertisement are not taken from the Phase and do not illustrate the final appearance of or the view of or from the Phase upon completion. They have been processed with computerized imaging techniques. The fittings, finishes, appliances, decorations and other objects therein may not appear in or the view may not be seen in or from the Phase or its surrounding area. They are for reference purpose only and do not constitute any offer, undertaking, representation or warranty whatsoever, whether express or implied, on the part of the vendor regarding the Phase or any part thereof. Please refer to the Sales Brochure for details of the Phase.<br><br>'
              
              + 'Prospective purchaser is advised to refer to the sales brochure for any information on the Phase.<br><br>'
              + 'This advertisement is published by the vendor or by another person with the consent of the vendor.<br><br>'
              + 'Please refer to the sales brochure for details.<br><br>'
              // + '#The above provisional street number is subject to confirmation when the Phase is completed.<br><br>'
              + 'Last Updated on: ' + moment(updated_at).format("Do MMM, YYYY"),
            continue: 'GO'
          },
          tc: {
            title: '<br><br><br><br><br>供買方參考資料及免責條款',
            content: '發展項目期數名稱：雲海發展項目（「發展項目」）的第二期（「期數」）（期數中住宅發展項目的41座洋房及26座別墅稱為「雲海別墅」）<br>'
              + '區域：馬鞍山｜期數的街道名稱及門牌號數：耀沙路9號<br>'
              + '賣方就期數指定的互聯網網站的網址：www.stbarths.com.hk/p2<br><br>'
              + '賣方：Good Assets Limited｜賣方之控權公司：新鴻基地產發展有限公司、Time Effort Limited、華益控股有限公司｜期數的認可人士：葉嘉偉｜期數的認可人士以其專業身份擔任經營人、董事或僱員的商號或法團：呂元祥建築師事務所（香港）有限公司｜期數的承建商：添輝建築有限公司｜就期數中的住宅物業的出售而代表擁有人行事的律師事務所：孖士打律師行、薛馮鄺岑律師行｜已為期數的建造提供貸款或已承諾為該項建造提供融資的認可機構：香港上海匯豐銀行有限公司｜已為期數的建造提供貸款的任何其他人：Sun Hung Kai Properties Holding Investment Limited<br><br>'
              + '本廣告/宣傳資料內載列的相片、圖像、繪圖或素描顯示純屬畫家對有關發展項目之想像。有關相片、圖像、繪圖或素描並非按照比例繪畫及/或可能經過電腦修飾處理。準買家如欲了解發展項目的詳情，請參閱售樓說明書。賣方亦建議準買家到有關發展地盤作實地考察，以對該發展地盤、其周邊地區環境及附近的公共設施有較佳了解。<br><br>'
              + '本廣告中之相片及繪圖並非於期數實景拍攝，亦並非說明期數最後完成之外觀或其景觀。該些相片及繪圖經電腦修飾處理，相片及繪圖內的裝置、裝修物料、設備、裝置物及其他物件等及其展示之景觀不一定會在期數或其附近範圍出現，僅供參考，且不構成任何賣方就期數或其任何部份不論明示或隱含之任何要約、承諾、陳述或保證。有關期數的詳細資料，請參閱售樓說明書。<br><br>'
              + '賣方建議準買方參閱有關售樓說明書，以了解期數的資料。<br><br>'
              + '本廣告由賣方發布或在賣方的同意下由另一人發布。<br><br>'
              + '詳情請參閱售樓說明書。<br><br>'
              // + '#此臨時門牌號數有待期數建成時確認。<br><br>'
              + '更新日期：' +  moment(updated_at).locale('zh-hk').format('L'),
            continue: '繼續'
          },
          sc: {
            title: '<br><br><br><br><br>供买方参考资料及免责条款',
            content: '发展项目期数名称：云海发展项目（「发展项目」）的第二期（「期数」）（期数中住宅发展项目的41座洋房及26座别墅称为「云海别墅」）<br>'
              + '区域：马鞍山｜期数的街道名称及门牌号数：耀沙路9号<br>'
              + '卖方就期数指定的互联网网站的网址：www.stbarths.com.hk/p2<br><br>'
              + '卖方：Good Assets Limited｜卖方之控权公司：新鸿基地产发展有限公司、Time Effort Limited、华益控股有限公司｜期数的认可人士：叶嘉伟｜期数的认可人士以其专业身份担任经营人、董事或僱员的商号或法团：吕元祥建筑师事务所（香港）有限公司｜期数的承建商：添辉建筑有限公司｜就期数中的住宅物业的出售而代表拥有人行事的律师事务所：孖士打律师行、薛冯邝岑律师行｜已为期数的建造提供贷款或已承诺为该项建造提供融资的认可机构：香港上海汇丰银行有限公司｜已为期数的建造提供贷款的任何其他人：Sun Hung Kai Properties Holding Investment Limited<br><br>'
              + '本广告/宣传资料内载列的相片、图像、绘图或素描显示纯属画家对有关发展项目之想像。有关相片、图像、绘图或素描并非按照比例绘画及/或可能经过电脑修饰处理。准买家如欲了解发展项目的详情，请参阅售楼说明书。卖方亦建议准买家到有关发展地盘作实地考察，以对该发展地盘、其周边地区环境及附近的公共设施有较佳了解。<br><br>'
              + '本广告中之相片及绘图并非于期数实景拍摄，亦并非说明期数最后完成之外观或其景观。该些相片及绘图经电脑修饰处理，相片及绘图内的装置、装修物料、设备、装置物及其他物件等及其展示之景观不一定会在期数或其附近范围出现，仅供参考，且不构成任何卖方就期数或其任何部份不论明示或隐含之任何要约、承诺、陈述或保证。有关期数的详细资料，请参阅售楼说明书。<br><br>'
              + '卖方建议准买方参阅有关售楼说明书，以了解期数的资料。<br><br>'
              + '本广告由卖方发布或在卖方的同意下由另一人发布。<br><br>'
              + '详情请参阅售楼说明书。<br><br>'
              // + '#此临时门牌号数有待期数建成时确认。<br><br>'
              + '更新日期：' +  moment(updated_at).locale('zh-hk').format('L'),
            continue: '继续'
          }
        })
*/
// let eng = {"contents":["<p>aaa<\/p>","<p>aaa<\/p>","<p>aaa<\/p>"],"titles":["aaa","aaa","aaa"]}
// let trad = {"contents":["traditional chinese notice",null,null],"titles":["t-trad-1",null,null]}
// let simp = {"contents":["traditional chinese notice",null,null],"titles":["t-simp-1",null,null]}

let eng = '';
let trad = '';
let simp = '';

let updated_at;


class Footer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ...this.props,
      footer: '/p2/desktop/footer/' + this.props.lang + '.png',
      footerPanelText: informationText[0],
      footerPanelTextMaster: informationText,
      footerPanelTextIndex: 0,
      footerCloseFlag: false,
      notice: {
        'en': '',
        'tc': '',
        'sc': '',
        exist: false
      }
    }

    this.closeFooterPanel = this.closeFooterPanel.bind(this);
    this.copyrightClickHandler = this.copyrightClickHandler.bind(this);
    this.informationClickHandler = this.informationClickHandler.bind(this);
    this.changePositioning = this.changePositioning.bind(this);
    this.continuePanel = this.continuePanel.bind(this);
    this.updateFoorterPanelText = this.updateFoorterPanelText.bind(this);
  }

  componentDidMount() {
    let t = this;

    console.log('Footer ' + this.props.lang);

    this.changePositioning();
    window.addEventListener('resize', this.changePositioning);
    window.addEventListener('scroll', this.changePositioning);

    // !!!!!!!!!! here
    // updated_at = 1528905600 * 1000
    // t.setState({
    //   updated_at: 1528905600 * 1000
    // })
    
    // t.updateFoorterPanelText();
    // !!!!!!!!!! here

    // !!!!!!!!!! there
    $.ajax({
      url: '/shk_cms2/public/index.php?list',
      success: function(d) {
        counter = counter + 1;
        t.setState({
          updated_at: d.last_update_date["1"].updated_at * 1000
        })
        updated_at = d.last_update_date["1"].updated_at * 1000
        // console.log(d)
        t.updateFoorterPanelText();
      }
    })

    $.ajax({
      url: '/shk_cms2/public/index.php?get_notice=eng',
      success: function(d) {
        counter = counter + 1;
        eng = d;
        console.log(eng);
        t.updateFoorterPanelText();
      }
    })
    
    $.ajax({
      url: '/shk_cms2/public/index.php?get_notice=trad',
      success: function(d) {
        counter = counter + 1;
        trad = d;
        console.log(trad);
        t.updateFoorterPanelText();
      }
    })
    
    $.ajax({
      url: '/shk_cms2/public/index.php?get_notice=simp',
      success: function(d) {
        counter = counter + 1;
        simp = d;
        console.log(simp);
        t.updateFoorterPanelText();
      }
    })
    // !!!!!!!!!! there
  }
  componentWillUpdate(){
    console.log('Footer update');
    console.log(this.state);
    const lang = window.location.pathname.split('/')[2];

    if (
      this.state.lang !== lang && lang
    ) {
      this.setState({
        lang: lang,
        footer: '/p2/desktop/footer/' + lang + '.png'
      });
    }
    this.changePositioning()
  }

  changePositioning() {
    let windowWidth = window.innerWidth;
    let windowHeight = window.innerHeight;

    let AppFooterTop = '';
    let footerButtonTop = '';
    let footerButtonHeight = '';

    let footerButtonCopyrightLeft = '';
    let footerButtonCopyrightWidth = '';

    let footerButtonInfoLeft = '';
    let footerButtonInfoWidth = '';

    if ($("#footer-panel-layer").width() > windowWidth) {
      windowWidth = $("#footer-panel-layer").width()
    } else
    if (windowWidth < 1100) {
      // AppFooterTop = 1100 * 0.75 - 145 + 'px';
      windowWidth = 1100;
    } else {
      // AppFooterTop = windowWidth * 0.75 - 145 + 'px';
    }

    // console.log(windowHeight);
    AppFooterTop = windowHeight - 149 + 'px';

    footerButtonTop = 1100 * 0.111 + 'px';
    footerButtonHeight = 1100 * 0.0164 + 'px';

    // console.log('Footer changePositioning ' + this.state.lang);

    if (this.state.lang === 'en') {
      footerButtonCopyrightLeft = (windowWidth - 1100) / 2 + 1100 * 0.373 + 'px';
      footerButtonCopyrightWidth = 1100 * 0.083 + 'px';

      footerButtonInfoLeft = (windowWidth - 1100) / 2 + 1100 * 0.462 + 'px';
      footerButtonInfoWidth = 1100 * 0.135 + 'px';
    } else {
      footerButtonCopyrightLeft = (windowWidth - 1100) / 2 + 1100 * 0.4669 + 'px';
      footerButtonCopyrightWidth = 1100 * 0.05027 + 'px';

      footerButtonInfoLeft = (windowWidth - 1100) / 2 + 1100 * 0.5214 + 'px';
      footerButtonInfoWidth = 1100 * 0.1195 + 'px';
    }

    // console.log(">>> " + windowWidth);

    document.getElementById('App-footer').style.top = AppFooterTop;

    document.getElementById('footer-button-copyright').style.top = footerButtonTop;
    document.getElementById('footer-button-copyright').style.height = footerButtonHeight;

    document.getElementById('footer-button-information').style.top = footerButtonTop;
    document.getElementById('footer-button-information').style.height = footerButtonHeight;

    document.getElementById('footer-button-copyright').style.left = footerButtonCopyrightLeft;
    document.getElementById('footer-button-copyright').style.width = footerButtonCopyrightWidth;

    document.getElementById('footer-button-information').style.left = footerButtonInfoLeft;
    document.getElementById('footer-button-information').style.width = footerButtonInfoWidth;
    setTimeout(function(){
      $('#footer-panel-layer').css({"height": "100vh"});
      // document.getElementById('footer-panel-layer').style.height = 'initial';
      // document.getElementById('footer-panel-layer').style.height = document.body.scrollHeight + 'px';
      // console.log(document.body.scrollHeight)
    }, 100)

    // Change lang
    // previous footer png
    // document.getElementById('footer-button-change-lang-left').style.top = 1100 * 0.0781090909 + 'px';
    // document.getElementById('footer-button-change-lang-left').style.height = 1100 * 0.0164 + 'px';

    // document.getElementById('footer-button-change-lang-right').style.top = 1100 * 0.0781090909 + 'px';
    // document.getElementById('footer-button-change-lang-right').style.height = 1100 * 0.0164 + 'px';

    // document.getElementById('footer-button-change-lang-left').style.left = (windowWidth - 1100) / 2 + 1100 * 0.941 + 'px';
    // document.getElementById('footer-button-change-lang-left').style.width = 1100 * 0.0209 + 'px';

    // document.getElementById('footer-button-change-lang-right').style.left = (windowWidth - 1100) / 2 + 1100 * 0.968 + 'px';
    // document.getElementById('footer-button-change-lang-right').style.width = 1100 * 0.0209 + 'px';

    // new footer png 2018.6.11
    document.getElementById('footer-button-change-lang-left').style.top = 1100 * 0.098109091 + 'px';
    document.getElementById('footer-button-change-lang-left').style.height = 1100 * 0.0164 + 'px';

    document.getElementById('footer-button-change-lang-right').style.top = 1100 * 0.098109091 + 'px';
    document.getElementById('footer-button-change-lang-right').style.height = 1100 * 0.0164 + 'px';

    document.getElementById('footer-button-change-lang-left').style.left = (windowWidth - 1100) / 2 + 1100 * 0.945 + 'px';
    document.getElementById('footer-button-change-lang-left').style.width = 1100 * 0.0209 + 'px';

    document.getElementById('footer-button-change-lang-right').style.left = (windowWidth - 1100) / 2 + 1100 * 0.972 + 'px';
    document.getElementById('footer-button-change-lang-right').style.width = 1100 * 0.0209 + 'px';

    // To SHKP
    document.getElementById('footer-to-shkp-area').style.height = 1100 * 0.0300363636 + 'px';
    document.getElementById('footer-to-shkp-area').style.width = 1100 * 0.17 + 'px';
    document.getElementById('footer-to-shkp-area').style.top = 1100 * 0.0391818182 + 'px';
    document.getElementById('footer-to-shkp-area').style.left = (windowWidth - 1100) / 2 + 1100 * 0.815 + 'px';

    // To P2
    document.getElementById('footer-to-p1').style.height = 1100 * 0.017 + 'px';
    document.getElementById('footer-to-p1').style.width = 1100 * 0.17 + 'px';
    document.getElementById('footer-to-p1').style.top = 1100 * 0.078 + 'px';
    document.getElementById('footer-to-p1').style.left = (windowWidth - 1100) / 2 + 1100 * 0.815 + 'px';

    // Date
    document.getElementById('footer-date-area').style.height = 1100 * 0.0164 + 'px';
    document.getElementById('footer-date-area').style.width = 1100 * 0.172454545 + 'px';
    /*
    if (this.state.lang === 'en') {
      document.getElementById('footer-date-area').style.top = 1100 * 0.113090909 + 'px';
      document.getElementById('footer-date-area').style.left = (windowWidth - 1100) / 2 + 1100 * 0.604 + 'px';
    } else {
      document.getElementById('footer-date-area').style.top = 1100 * 0.111009091 + 'px';
      document.getElementById('footer-date-area').style.left = (windowWidth - 1100) / 2 + 1100 * 0.58 + 'px';
    }
    */
    if (this.state.lang === 'en') {
      document.getElementById('footer-date-area').style.top = 1100 * 0.113 + 'px';
      document.getElementById('footer-date-area').style.left = (windowWidth - 1100) / 2 + 1100 * 0.815 + 'px';
    } else
    if (this.state.lang === 'tc') {
      document.getElementById('footer-date-area').style.top = 1100 * 0.113 + 'px';
      document.getElementById('footer-date-area').style.left = (windowWidth - 1100) / 2 + 1100 * 0.815 + 'px';
    } else {
      document.getElementById('footer-date-area').style.top = 1100 * 0.113 + 'px';
      document.getElementById('footer-date-area').style.left = (windowWidth - 1100) / 2 + 1100 * 0.815 + 'px';
    }

    // continue & close button

    let footerPanelLeft = $("#footer-panel").offset().left + 930;
    console.log(footerPanelLeft)


      if ($("#footer-panel-layer").width() > window.innerWidth) {
        console.log("if " + (footerPanelLeft - $(document).scrollLeft()))
        $('#footer-continue-button').css({
          "left": (footerPanelLeft - $(document).scrollLeft()) + "px"
        });
        $('#footer-close-button').css({
          "left": (footerPanelLeft - $(document).scrollLeft()) + "px"
        });
      } else {
        $('#footer-continue-button').css({
          "left": (footerPanelLeft) + "px"
        });
        $('#footer-close-button').css({
          "left": (footerPanelLeft) + "px"
        });
      }
    // console.log()
    // if ($("#footer-panel-layer").width() > window.innerWidth) {
    //   console.log("if")
    //   console.log($("#footer-panel-layer").width() * 0.8508 - $(document).scrollLeft())
    //   $('#footer-continue-button').css({
    //     "left": (footerPanelLeft) + "px"
    //   });
    //   $('#footer-close-button').css({
    //     "left": (footerPanelLeft) + "px"
    //   });
    // } else
    // if (window.innerWidth < 1100) {
    //   console.log("else if")
    //   console.log((1100 - $(document).scrollLeft()) * 0.91)
    //   $('#footer-continue-button').css({
    //     "left": (1100 - $(document).scrollLeft()) * 0.91 + "px"
    //   });
    //   $('#footer-close-button').css({
    //     "left": (1100 - $(document).scrollLeft()) * 0.91 + "px"
    //   });
    // } else {
    //   console.log("else")
    //   console.log(($("#footer-panel-layer").width() - 1100) / 2 + 1100 * 0.91)
    //   $('#footer-continue-button').css({
    //     "left": ($("#footer-panel-layer").width() - 1100) / 2 + 1100 * 0.91 + "px"
    //   });
    //   $('#footer-close-button').css({
    //     "left": ($("#footer-panel-layer").width() - 1100) / 2 + 1100 * 0.91 + "px"
    //   });
    // }


  }

  updateFoorterPanelText () {
    let t = this;

    // !!!!!!!!!! here
    if (counter === 4) {
      console.log(">>>>> informationText")
      informationText.pop();
      informationText.push(
        {
          en: {
            title: '<br><br><br><br><br>Information to purchasers and disclaimers',
            content: 'Name of the Phase of the Development: Phase 2 (“the Phase”) of St. Barths Development (“the Development”)<br>'
              + '(41 Houses and 26 Villas of the residential development in the Phase are called “Crown of St. Barths”)<br>'
              + 'District: Ma On Shan | Name of Street and Street Number of the Phase: 9 Yiu Sha Road<br>'
              + 'The website address designated by the Vendor for the Phase: www.stbarths.com.hk/p2<br><br>'
              + 'Vendor: Good Assets Limited | Holding companies of the Vendor: Sun Hung Kai Properties Limited, Time Effort Limited, China Benefit Holdings Limited | Authorized person of the Phase: Ip Kar-Wai Kelvin | Firm or corporation of which the authorized person of the Phase is a proprietor, director or employee in his professional capacity: Ronald Lu & Partners (Hong Kong) Limited | Building contractor of the Phase: Teamfield Building Contractors Limited | The firm of solicitors acting for the owner in relation to the sale of residential properties in the Phase: Mayer Brown, Sit, Fung, Kwong & Shum | Authorized institution that has made a loan, or has undertaken to provide finance for the construction of the Phase: The Hongkong and Shanghai Banking Corporation Limited | Any other person who had made a loan for the construction of the Phase: Sun Hung Kai Properties Holding Investment Limited<br><br>'
              + 'The photographs, images, drawings or sketches shown in this advertisement/promotional material represent an artist’s impression of the development concerned only. They are not drawn to scale and/or may have been edited and processed with computerized imaging techniques. Prospective purchasers should make reference to the sales brochure for details of the development. The vendor also advises prospective purchasers to conduct an on-site visit for a better understanding of the development site, its surrounding environment and the public facilities nearby.<br><br>'
              + 'The photos and drawings shown in this advertisement are not taken from the Phase and do not illustrate the final appearance of or the view of or from the Phase upon completion. They have been processed with computerized imaging techniques. The fittings, finishes, appliances, decorations and other objects therein may not appear in or the view may not be seen in or from the Phase or its surrounding area. They are for reference purpose only and do not constitute any offer, undertaking, representation or warranty whatsoever, whether express or implied, on the part of the vendor regarding the Phase or any part thereof. Please refer to the Sales Brochure for details of the Phase.<br><br>'
              
              + 'Prospective purchaser is advised to refer to the sales brochure for any information on the Phase.<br><br>'
              + 'This advertisement is published by the vendor or by another person with the consent of the vendor.<br><br>'
              + 'Please refer to the sales brochure for details.<br><br>'
              // + '#The above provisional street number is subject to confirmation when the Phase is completed.<br><br>'
              + 'Last Updated on: ' + moment(updated_at).format("Do MMM, YYYY"),
            continue: 'GO'
          },
          tc: {
            title: '<br><br><br><br><br>供買方參考資料及免責條款',
            content: '發展項目期數名稱：雲海發展項目（「發展項目」）的第二期（「期數」）（期數中住宅發展項目的41座洋房及26座別墅稱為「雲海別墅」）<br>'
              + '區域：馬鞍山｜期數的街道名稱及門牌號數：耀沙路9號<br>'
              + '賣方就期數指定的互聯網網站的網址：www.stbarths.com.hk/p2<br><br>'
              + '賣方：Good Assets Limited｜賣方之控權公司：新鴻基地產發展有限公司、Time Effort Limited、華益控股有限公司｜期數的認可人士：葉嘉偉｜期數的認可人士以其專業身份擔任經營人、董事或僱員的商號或法團：呂元祥建築師事務所（香港）有限公司｜期數的承建商：添輝建築有限公司｜就期數中的住宅物業的出售而代表擁有人行事的律師事務所：孖士打律師行、薛馮鄺岑律師行｜已為期數的建造提供貸款或已承諾為該項建造提供融資的認可機構：香港上海匯豐銀行有限公司｜已為期數的建造提供貸款的任何其他人：Sun Hung Kai Properties Holding Investment Limited<br><br>'
              + '本廣告/宣傳資料內載列的相片、圖像、繪圖或素描顯示純屬畫家對有關發展項目之想像。有關相片、圖像、繪圖或素描並非按照比例繪畫及/或可能經過電腦修飾處理。準買家如欲了解發展項目的詳情，請參閱售樓說明書。賣方亦建議準買家到有關發展地盤作實地考察，以對該發展地盤、其周邊地區環境及附近的公共設施有較佳了解。<br><br>'
              + '本廣告中之相片及繪圖並非於期數實景拍攝，亦並非說明期數最後完成之外觀或其景觀。該些相片及繪圖經電腦修飾處理，相片及繪圖內的裝置、裝修物料、設備、裝置物及其他物件等及其展示之景觀不一定會在期數或其附近範圍出現，僅供參考，且不構成任何賣方就期數或其任何部份不論明示或隱含之任何要約、承諾、陳述或保證。有關期數的詳細資料，請參閱售樓說明書。<br><br>'
              + '賣方建議準買方參閱有關售樓說明書，以了解期數的資料。<br><br>'
              + '本廣告由賣方發布或在賣方的同意下由另一人發布。<br><br>'
              + '詳情請參閱售樓說明書。<br><br>'
              // + '#此臨時門牌號數有待期數建成時確認。<br><br>'
              + '更新日期：' +  moment(updated_at).locale('zh-hk').format('L'),
            continue: '繼續'
          },
          sc: {
            title: '<br><br><br><br><br>供买方参考资料及免责条款',
            content: '发展项目期数名称：云海发展项目（「发展项目」）的第二期（「期数」）（期数中住宅发展项目的41座洋房及26座别墅称为「云海别墅」）<br>'
              + '区域：马鞍山｜期数的街道名称及门牌号数：耀沙路9号<br>'
              + '卖方就期数指定的互联网网站的网址：www.stbarths.com.hk/p2<br><br>'
              + '卖方：Good Assets Limited｜卖方之控权公司：新鸿基地产发展有限公司、Time Effort Limited、华益控股有限公司｜期数的认可人士：叶嘉伟｜期数的认可人士以其专业身份担任经营人、董事或僱员的商号或法团：吕元祥建筑师事务所（香港）有限公司｜期数的承建商：添辉建筑有限公司｜就期数中的住宅物业的出售而代表拥有人行事的律师事务所：孖士打律师行、薛冯邝岑律师行｜已为期数的建造提供贷款或已承诺为该项建造提供融资的认可机构：香港上海汇丰银行有限公司｜已为期数的建造提供贷款的任何其他人：Sun Hung Kai Properties Holding Investment Limited<br><br>'
              + '本广告/宣传资料内载列的相片、图像、绘图或素描显示纯属画家对有关发展项目之想像。有关相片、图像、绘图或素描并非按照比例绘画及/或可能经过电脑修饰处理。准买家如欲了解发展项目的详情，请参阅售楼说明书。卖方亦建议准买家到有关发展地盘作实地考察，以对该发展地盘、其周边地区环境及附近的公共设施有较佳了解。<br><br>'
              + '本广告中之相片及绘图并非于期数实景拍摄，亦并非说明期数最后完成之外观或其景观。该些相片及绘图经电脑修饰处理，相片及绘图内的装置、装修物料、设备、装置物及其他物件等及其展示之景观不一定会在期数或其附近范围出现，仅供参考，且不构成任何卖方就期数或其任何部份不论明示或隐含之任何要约、承诺、陈述或保证。有关期数的详细资料，请参阅售楼说明书。<br><br>'
              + '卖方建议准买方参阅有关售楼说明书，以了解期数的资料。<br><br>'
              + '本广告由卖方发布或在卖方的同意下由另一人发布。<br><br>'
              + '详情请参阅售楼说明书。<br><br>'
              // + '#此临时门牌号数有待期数建成时确认。<br><br>'
              + '更新日期：' +  moment(updated_at).locale('zh-hk').format('L'),
            continue: '继续'
          }
        }
      )

      if (eng == 0 || trad == 0 || simp == 0 || 
          eng.contents.length === 0 || trad.contents.length === 0 || simp.contents.length === 0 ||
          eng.titles.length === 0 || trad.titles.length === 0 || simp.titles.length === 0) {

      } else {
        for (let i = 0; i < 3; i++) {
          if (eng.contents[i] && trad.contents[i] && simp.contents[i] &&
              eng.titles[i] && trad.titles[i] && simp.titles[i]) {

            let appendBr = ''
            if (i === 0) {
              appendBr = '<br><br><br><br><br>'
            }

            t.setState({
              notice:  {
                'en': t.state.notice.en 
                  + '<div style="color: rgba(51,102,199,1); font-size: 12.5pt">' + appendBr + eng.titles[i] + '</div>'
                  + '<div style="font-size: 11pt">' + eng.contents[i] + '</div>'
                  + '</br>',
                'tc': t.state.notice.tc 
                  + '<div style="color: rgba(51,102,199,1); font-size: 12.5pt">' + appendBr + trad.titles[i] + '</div>'
                  + '<div style="font-size: 11pt">' + trad.contents[i] + '</div>'
                  + '</br>',
                'sc': t.state.notice.sc 
                  + '<div style="color: rgba(51,102,199,1); font-size: 12.5pt">' + appendBr + simp.titles[i] + '</div>'
                  + '<div style="font-size: 11pt">' + simp.contents[i] + '</div>'
                  + '</br>',
                exist: true
              }
            });
          }
        }
      }

      t.setState({
        footerPanelText: informationText[0],
        footerPanelTextMaster: informationText,
      });
    }
    // !!!!!!!!!! here

    // !!!!!!!!!! there
    // informationText.pop();
    // informationText.push(
    //           {
    //   en: {
    //     title: '<br><br><br><br><br>Information to purchasers and disclaimers',
    //     content: 'Name of the Phase of the Development: Phase 2 (“the Phase”) of St. Barths Development (“the Development”)<br>'
    //       + '(41 Houses and 26 Villas of the residential development in the Phase are called “Crown of St. Barths”)<br>'
    //       + 'District: Ma On Shan | Name of Street and Street Number of the Phase: 9 Yiu Sha Road<br>'
    //       + 'The website address designated by the Vendor for the Phase: www.stbarths.com.hk/p2<br><br>'
    //       + 'Vendor: Good Assets Limited | Holding companies of the Vendor: Sun Hung Kai Properties Limited, Time Effort Limited, China Benefit Holdings Limited | Authorized person of the Phase: Ip Kar-Wai Kelvin | Firm or corporation of which the authorized person of the Phase is a proprietor, director or employee in his professional capacity: Ronald Lu & Partners (Hong Kong) Limited | Building contractor of the Phase: Teamfield Building Contractors Limited | The firm of solicitors acting for the owner in relation to the sale of residential properties in the Phase: Mayer Brown, Sit, Fung, Kwong & Shum | Authorized institution that has made a loan, or has undertaken to provide finance for the construction of the Phase: The Hongkong and Shanghai Banking Corporation Limited | Any other person who had made a loan for the construction of the Phase: Sun Hung Kai Properties Holding Investment Limited<br><br>'
    //       + 'The photographs, images, drawings or sketches shown in this advertisement/promotional material represent an artist’s impression of the development concerned only. They are not drawn to scale and/or may have been edited and processed with computerized imaging techniques. Prospective purchasers should make reference to the sales brochure for details of the development. The vendor also advises prospective purchasers to conduct an on-site visit for a better understanding of the development site, its surrounding environment and the public facilities nearby.<br><br>'
    //       + 'The photos and drawings shown in this advertisement are not taken from the Phase and do not illustrate the final appearance of or the view of or from the Phase upon completion. They have been processed with computerized imaging techniques. The fittings, finishes, appliances, decorations and other objects therein may not appear in or the view may not be seen in or from the Phase or its surrounding area. They are for reference purpose only and do not constitute any offer, undertaking, representation or warranty whatsoever, whether express or implied, on the part of the vendor regarding the Phase or any part thereof. Please refer to the Sales Brochure for details of the Phase.<br><br>'
          
    //       + 'Prospective purchaser is advised to refer to the sales brochure for any information on the Phase.<br><br>'
    //       + 'This advertisement is published by the vendor or by another person with the consent of the vendor.<br><br>'
    //       + 'Please refer to the sales brochure for details.<br><br>'
    //       // + '#The above provisional street number is subject to confirmation when the Phase is completed.<br><br>'
    //       + 'Last Updated on: ' + moment(updated_at).format("Do MMM, YYYY"),
    //     continue: 'GO'
    //   },
    //   tc: {
    //     title: '<br><br><br><br><br>供買方參考資料及免責條款',
    //     content: '發展項目期數名稱：雲海發展項目（「發展項目」）的第二期（「期數」）（期數中住宅發展項目的41座洋房及26座別墅稱為「雲海別墅」）<br>'
    //       + '區域：馬鞍山｜期數的街道名稱及門牌號數：耀沙路9號<br>'
    //       + '賣方就期數指定的互聯網網站的網址：www.stbarths.com.hk/p2<br><br>'
    //       + '賣方：Good Assets Limited｜賣方之控權公司：新鴻基地產發展有限公司、Time Effort Limited、華益控股有限公司｜期數的認可人士：葉嘉偉｜期數的認可人士以其專業身份擔任經營人、董事或僱員的商號或法團：呂元祥建築師事務所（香港）有限公司｜期數的承建商：添輝建築有限公司｜就期數中的住宅物業的出售而代表擁有人行事的律師事務所：孖士打律師行、薛馮鄺岑律師行｜已為期數的建造提供貸款或已承諾為該項建造提供融資的認可機構：香港上海匯豐銀行有限公司｜已為期數的建造提供貸款的任何其他人：Sun Hung Kai Properties Holding Investment Limited<br><br>'
    //       + '本廣告/宣傳資料內載列的相片、圖像、繪圖或素描顯示純屬畫家對有關發展項目之想像。有關相片、圖像、繪圖或素描並非按照比例繪畫及/或可能經過電腦修飾處理。準買家如欲了解發展項目的詳情，請參閱售樓說明書。賣方亦建議準買家到有關發展地盤作實地考察，以對該發展地盤、其周邊地區環境及附近的公共設施有較佳了解。<br><br>'
    //       + '本廣告中之相片及繪圖並非於期數實景拍攝，亦並非說明期數最後完成之外觀或其景觀。該些相片及繪圖經電腦修飾處理，相片及繪圖內的裝置、裝修物料、設備、裝置物及其他物件等及其展示之景觀不一定會在期數或其附近範圍出現，僅供參考，且不構成任何賣方就期數或其任何部份不論明示或隱含之任何要約、承諾、陳述或保證。有關期數的詳細資料，請參閱售樓說明書。<br><br>'
    //       + '賣方建議準買方參閱有關售樓說明書，以了解期數的資料。<br><br>'
    //       + '本廣告由賣方發布或在賣方的同意下由另一人發布。<br><br>'
    //       + '詳情請參閱售樓說明書。<br><br>'
    //       // + '#此臨時門牌號數有待期數建成時確認。<br><br>'
    //       + '更新日期：' +  moment(updated_at).locale('zh-hk').format('L'),
    //     continue: '繼續'
    //   },
    //   sc: {
    //     title: '<br><br><br><br><br>供买方参考资料及免责条款',
    //     content: '发展项目期数名称：云海发展项目（「发展项目」）的第二期（「期数」）（期数中住宅发展项目的41座洋房及26座别墅称为「云海别墅」）<br>'
    //       + '区域：马鞍山｜期数的街道名称及门牌号数：耀沙路9号<br>'
    //       + '卖方就期数指定的互联网网站的网址：www.stbarths.com.hk/p2<br><br>'
    //       + '卖方：Good Assets Limited｜卖方之控权公司：新鸿基地产发展有限公司、Time Effort Limited、华益控股有限公司｜期数的认可人士：叶嘉伟｜期数的认可人士以其专业身份担任经营人、董事或僱员的商号或法团：吕元祥建筑师事务所（香港）有限公司｜期数的承建商：添辉建筑有限公司｜就期数中的住宅物业的出售而代表拥有人行事的律师事务所：孖士打律师行、薛冯邝岑律师行｜已为期数的建造提供贷款或已承诺为该项建造提供融资的认可机构：香港上海汇丰银行有限公司｜已为期数的建造提供贷款的任何其他人：Sun Hung Kai Properties Holding Investment Limited<br><br>'
    //       + '本广告/宣传资料内载列的相片、图像、绘图或素描显示纯属画家对有关发展项目之想像。有关相片、图像、绘图或素描并非按照比例绘画及/或可能经过电脑修饰处理。准买家如欲了解发展项目的详情，请参阅售楼说明书。卖方亦建议准买家到有关发展地盘作实地考察，以对该发展地盘、其周边地区环境及附近的公共设施有较佳了解。<br><br>'
    //       + '本广告中之相片及绘图并非于期数实景拍摄，亦并非说明期数最后完成之外观或其景观。该些相片及绘图经电脑修饰处理，相片及绘图内的装置、装修物料、设备、装置物及其他物件等及其展示之景观不一定会在期数或其附近范围出现，仅供参考，且不构成任何卖方就期数或其任何部份不论明示或隐含之任何要约、承诺、陈述或保证。有关期数的详细资料，请参阅售楼说明书。<br><br>'
    //       + '卖方建议准买方参阅有关售楼说明书，以了解期数的资料。<br><br>'
    //       + '本广告由卖方发布或在卖方的同意下由另一人发布。<br><br>'
    //       + '详情请参阅售楼说明书。<br><br>'
    //       // + '#此临时门牌号数有待期数建成时确认。<br><br>'
    //       + '更新日期：' +  moment(updated_at).locale('zh-hk').format('L'),
    //     continue: '继续'
    //   }
    // }
    // )

    // t.setState({
    //   footerPanelText: informationText[0],
    //   footerPanelTextMaster: informationText,
    // });
    // !!!!!!!!!! there


  }

  continuePanel (e) {
    let t = this;
    if (!this.state.notice.exist) {
      t.closeFooterPanel();
    } else {

      t.setState({
        notice:  {
          'en': '<div style="color: rgba(51,102,199,1); font-size: 12.5pt">' + informationText[0].en.title + '</div>'
            + '<div style="font-size: 11pt">' +  informationText[0].en.content + '</div>',
          'tc': '<div style="color: rgba(51,102,199,1); font-size: 12.5pt">' + informationText[0].tc.title + '</div>'
            + '<div style="font-size: 11pt">' +  informationText[0].tc.content + '</div>',
          'sc': '<div style="color: rgba(51,102,199,1); font-size: 12.5pt">' + informationText[0].sc.title + '</div>'
            + '<div style="font-size: 11pt">' +  informationText[0].sc.content + '</div>',
          exist: false
        }
      });
    }
  }

  closeFooterPanel (e) {
    let t = this;
    setTimeout(function(){
     $('#footer-panel-layer').css({"z-index": "-10"});
      t.setState({
        footerPanelText: informationText[informationText.length - 1],
        footerPanelTextIndex: 0
      });
    }, 400);
    $('#footer-panel-layer').removeClass('show-footer-panel-layer');
  }
  copyrightClickHandler(e) {
    this.setState({
      footerPanelText: copyrightText,
      footerCloseFlag: true
    });
    $('#footer-panel-layer').css({"z-index": "1000", "height": "100vh"});
    $('#footer-panel-layer').addClass('show-footer-panel-layer');
  }

  informationClickHandler(e) {
    this.setState({
      footerPanelText: informationText[informationText.length - 1],
      footerCloseFlag: true
    });
    $('#footer-panel-layer').css({"z-index": "1000", "height": "100vh"});
    $('#footer-panel-layer').addClass('show-footer-panel-layer');
  }

  changeUrlByLang(dir) {
    console.log(dir)
    browserHistory.push('/#/en')
  }



  render() {

    let dateArea = '';
    let linkToShkp = '';
    let linkToP1 = '';
    let updated_at = this.state.updated_at ? this.state.updated_at : ''

    if (this.props.lang == 'sc') {
      dateArea = '更新日期：' +  (updated_at ? moment(updated_at).locale('zh-cn').format('L') : '');
      linkToShkp = 'https://www.shkp.com/zh-CN/';
      linkToP1 = '/p1/#/sc';
    } else
    if (this.props.lang == 'tc') {
      dateArea = '更新日期：' +  (updated_at ? moment(updated_at).locale('zh-hk').format('L') : '');
      linkToShkp = 'https://www.shkp.com/zh-HK/';
      linkToP1 = '/p1/#/tc';
    } else {
      dateArea = 'Last Updated on: ' + (updated_at ? moment(updated_at).locale('en').format("Do MMM, YYYY") : '');
      linkToShkp = 'https://www.shkp.com/en-US/';
      linkToP1 = '/p1/#/en';
    }


    return <div>

      <div id='footer-panel-layer' className='' style={{ 'height' : '100vh'}}>
        <div id='footer-panel-container' className='' style={{}}>
          <div id='footer-panel' className='' style={{}}>
          <Scrollbars
              renderTrackHorizontal={props => <div {...props} className="track-horizontal"/>}
              renderThumbHorizontal={props => <div {...props} className="thumb-horizontal"/>} 
              autoHide
              autoHideTimeout={1000}
              autoHideDuration={200}
              className=''
              style={{
                'fontSize': '12px',
                'overflowX': 'hidden',
                'height': '80vh'
              }}>
            <div id='footer-close-button' style={{
              'position': 'fixed',

              'textAlign': 'right',
              'top': '70px',
              'right': '0',
              'color': 'rgba(51,102,199,1)',
              'cursor': 'pointer',
              'display': this.state.footerCloseFlag ? 'block' : 'none',

              'width': '50px',
              'height': '50px'
            }}>
              <i className='material-icons' style={{
                // 'position': 'fixed',
                'position': 'relative',
                'verticalAlign': 'bottom',
                'fontSize': '48px'
              }} onClick={this.closeFooterPanel}>clear</i>
            </div>


            {
              this.state.footerCloseFlag ? 
              <div>
                <div dangerouslySetInnerHTML={{__html: this.state.footerPanelText[this.props.lang].title}} style={{
                  'color': 'rgba(51,102,199,1)',
                  'fontSize': '12.5pt'
                }}>
                  
                </div>
                <br/>
                <div dangerouslySetInnerHTML={{__html: this.state.footerPanelText[this.props.lang].content}} style={{
                  'fontSize': '11pt',
                  'textAlign': 'justify'
                }}></div>
              </div>
              : ( this.state.notice.exist ?
                <div dangerouslySetInnerHTML={{__html: this.state.notice[this.props.lang]}}>
                  
                </div>
                :
                <div>
                  <div dangerouslySetInnerHTML={{__html: this.state.footerPanelText[this.props.lang].title}} style={{
                    'color': 'rgba(51,102,199,1)',
                    'fontSize': '12.5pt'
                  }}>
                    
                  </div>
                  <br/>
                  <div dangerouslySetInnerHTML={{__html: this.state.footerPanelText[this.props.lang].content}} style={{
                    'fontSize': '11pt',
                    'textAlign': 'justify'
                  }}></div>
                </div>
                )
            }







            <div id='footer-continue-button' style={{
              'position': 'fixed',

              'textAlign': 'right',
              'top': '70px',
              'right': '0',
              'color': 'rgba(51,102,199,1)',
              'cursor': 'pointer',
              'display': this.state.footerCloseFlag ? 'none' : 'block',

              'width': '65px',
              'height': '20px'
            }}>
              <span style={{
                // 'position': 'fixed',
                'position': 'relative',
                'verticalAlign': 'text-bottom',
                'top': '-2px',
                'fontSize': '16px'
              }} onClick={this.continuePanel}>
                {this.state.footerPanelText[this.props.lang].continue}
              </span>
              <i className='material-icons' style={{
                // 'position': 'fixed',
                'position': 'relative',
                'verticalAlign': 'bottom'
              }} onClick={this.continuePanel}>play_arrow</i>
            </div>

          </Scrollbars>

          </div>
        </div>

      </div>

      <div id='App-footer' className='App-footer'>
        <div className='footer-layer'>
          
        </div>
        <div className='footer-notes'>
          <img src={this.state.footer} style={{
            'width': '100%'
          }}/>
        </div>

        <div id='footer-button-copyright' className='footer-button' style={{
          'width': '8.3%',
          'left': '37.3%'
        }} onClick={this.copyrightClickHandler}></div>

        <div id='footer-button-information' className='footer-button' style={{
          'width': '8.3%',
          'left': '37.3%'
        }} onClick={this.informationClickHandler}></div>


        <Link to={() => {
          let lang = this.props.lang == 'en' ? 'tc' : 'en';
          let pathArr = window.location.pathname.split('/');
          let pageName = pathArr[pathArr.length-1];

          return '/p2/' + lang + '/' + pageName

          // let subRoute = window.location.hash.split('/')[2] ? '/' + window.location.hash.split('/')[2] : ''
          // return '/' + lang + subRoute
        }}>
          <div id='footer-button-change-lang-left' className='footer-button' style={{
            'width': '3%',
            'left': '93.6%',
            'height': '10%',
            'top': '80%',
            // 'backgroundColor': 'rgba(0,0,0,0.1)'
          }} // onClick={() => this.changeUrlByLang('left')}></div>
          ></div>
        </Link>

        <Link to={() => {
          let lang = this.props.lang == 'sc' ? 'tc' : 'sc'
          let pathArr = window.location.pathname.split('/');
          let pageName = pathArr[pathArr.length-1];

          return '/p2/' + lang + '/' + pageName
          
          // let subRoute = window.location.hash.split('/')[2] ? '/' + window.location.hash.split('/')[2] : ''
          // return '/' + lang + subRoute
        }}>
          <div id='footer-button-change-lang-right' className='footer-button' style={{
            'width': '1.4%',
            'left': '97.4%',
            'height': '10%',
            'top': '80%',
            // 'backgroundColor': 'rgba(0,0,0,0.1)'
          }} // onClick={() => this.changeUrlByLang('right')}></div>
          ></div>
        </Link>

        <a href={linkToShkp} target="_blank">
          <div id='footer-to-shkp-area' style={{
            // border: '1px solid rgb(142, 142, 142)',
            position: 'absolute',
            fontSize: '12px',
            'width': '1.4%',
            'left': '94.4%',
            'height': '10%',
            'top': '85%',
          }}>

          </div>
        </a>

        <a href={linkToP1}>
          <div id='footer-to-p1' style={{
            // border: '1px solid rgb(142, 142, 142)',
            position: 'absolute',
            fontSize: '12px',
            'width': '1.4%',
            'left': '94.4%',
            'height': '10%',
            'top': '85%',
          }}>

          </div>
        </a>

        <div id='footer-date-area' style={{
          
          color: 'rgb(142, 142, 142)',
          position: 'absolute',
          fontSize: '12px',
          width: '1.4%',
          left: '94.4%',
          height: '10%',
          top: '85%',
          textAlign: 'right',
        }}>
          {dateArea}
          
        </div>

      </div>

    </div>
  }

}

export default Footer;



// WEBPACK FOOTER //
// ./src/desktop/layout/Footer.js